import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../public/assets/img/svg/acon_logo_colored.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "acon_icon",
  class: "m-4 w-48"
}, null, -1)
const _hoisted_2 = { class: "text-wrapper flex items-center text-center justify-center" }
const _hoisted_3 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IonButton = _resolveComponent("IonButton")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.t("warteraum.titel")), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.t("warteraum.infoText")), 1),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_IonButton, {
                  fill: "flat",
                  size: "small",
                  color: "dark",
                  onClick: _ctx.logout
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("buttons.logout")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _createVNode(_component_Footer)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}